import Link from 'next/link'
import type { MatchedHeaderCategory } from '../hooks/useHeaderCategories'
import { usePageType } from '../../../lib/hooks/usePageType'
import { useTranslation } from 'next-i18next'

type Props = {
  categories: MatchedHeaderCategory[]
  language: string
  onItemClick?: () => void
  getHref: (category: any, locale: AppLocale) => string
}

export function CityCategoriesMobileList({
  categories,
  language,
  onItemClick,
  getHref,
}: Props) {
  if (!categories.length) return null
  const { type, citySlug } = usePageType()
  const isCategoryPage = type === 'category'
  const { t } = useTranslation('common')
  const allCategoriesLabel =
    t('all-activities') !== 'all-categories'
      ? t('all-activities')
      : 'All categories'
  return (
    <div className="fixed left-0 right-0 top-14 xs:top-20 z-50 bg-white w-screen max-h-dvh overflow-y-auto">
      <ul className="flex flex-col">
        {isCategoryPage && citySlug && (
          <li key="__all_categories__">
            <Link
              href={`/c/${citySlug}`}
              className="block w-full px-4 py-3 text-base"
              onClick={onItemClick}
            >
              {allCategoriesLabel}
            </Link>
          </li>
        )}
        {categories.map((item) => (
          <li key={item._id}>
            <Link
              href={getHref(item.category, language as AppLocale)}
              className="block w-full px-4 py-3 text-base"
              onClick={onItemClick}
            >
              {item.label}
            </Link>
          </li>
        ))}
        {/* Spacer to provide empty space at end of list */}
        <li aria-hidden="true" className="pointer-events-none select-none">
          <div style={{ height: 200 }} />
        </li>
      </ul>
    </div>
  )
}
